import EventActionProto from '../../event-action-proto';

module.exports = class SessionMeetingDelete extends EventActionProto {

    constructor(uid, data, sid, companyId, sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            reminder    : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {

        // never initialized
        if (!gd.session.reminders) {
            // ignore
        } else {
            gd.session.reminders.remove(this.data.id, true)
        }

        gd.bus.triggerEvent('reminder.{0}:delete'.f(this.data.id));
        gd.modelBus.newUpdate('reminder', this.method, this.header.reminder.id, this.data, this.header)

        super.process()
    }
}